export function stripQueryStringAndHash(url) {
  return url.split('?')[0].split('#')[0];
}

export function queryStringFromObject(obj, appendQueryStringToken = true) {
  var queryString = Object.keys(obj)
    .reduce((items, key) => [...items, `${key}=${encodeURIComponent(obj[key])}`], [])
    .join('&');

  if (appendQueryStringToken && queryString.length > 0) {
    queryString = `?${queryString}`;
  }
  return queryString;
}

export function objectFromQueryString(url) {
  var obj = {};

  var tokenIndex = url.indexOf('?');
  if (tokenIndex > -1) {
    var queryString = url.substring(tokenIndex + 1);
    if (queryString !== '') {
      queryString.split('&').forEach(pair => {
        let [key, value] = pair.split('=');
        obj[key] = decodeURIComponent(value);
      });
    }
  }

  return obj;
}

function parseUrl(url) {
  var queryIndex = url.indexOf('?');
  if (queryIndex === -1) {
    return {};
  }

  var pairs = url
    .substring(queryIndex)
    .slice(1)
    .split('&');

  var result = {};
  pairs.forEach(function(pair) {
    pair = pair.split('=');
    if (pair[0] !== '') {
      result[pair[0]] = decodeURIComponent(pair[1] || '');
    }
  });

  return JSON.parse(JSON.stringify(result));
}

function hasQueryString(url, key, value = null) {
  var qs = parseUrl(url);
  var has = false;
  if (qs.hasOwnProperty(key)) {
    if (value !== null) {
      has = qs[key] === value;
    } else {
      has = true;
    }
  }
  return has;
}

function buildUrl(route, newQueryStringObject) {
  var newRoute = route;
  var currentQueryStringObject = {};
  if (!newRoute) {
    newRoute = '';
  } else {
    var tokenIndex = newRoute.indexOf('?');
    if (tokenIndex > -1) {
      currentQueryStringObject = parseUrl(newRoute);
      newRoute = newRoute.substring(0, tokenIndex);
    }
  }

  var queryStringObject = Object.assign(currentQueryStringObject, newQueryStringObject);
  var qs = queryStringFromObject(queryStringObject);
  if (qs.length > 0) {
    newRoute = newRoute + qs;
  }

  return newRoute;
}

function removeParams(url, params) {
  return params.reduce(function(_url, param) {
    return removeParam(_url, param);
  }, url);
}

function removeParam(url, param) {
  var modifiedUrl = url;
  var queryIndex = url.indexOf('?');
  if (queryIndex !== -1) {
    var route = url.substring(0, queryIndex);
    var query = url.substring(queryIndex + 1);
    var regex = new RegExp('&' + param + '(=[^&]*)?|^' + param + '(=[^&]*)?&?');
    query = query.replace(regex, '');
    modifiedUrl = route + (query.length > 0 ? '?' : '') + query;
  }
  return modifiedUrl;
}

function getKey(url, key) {
  key = key.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + key + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  var value;
  if (!results) {
    value = null;
  } else if (!results[2]) {
    value = '';
  } else {
    value = decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  return value;
}

function setKey(url, key, value) {
  var newUrl = url;
  var regex = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  if (url.match(regex)) {
    newUrl = url.replace(regex, '$1' + key + '=' + value + '$2');
  } else {
    var separator = url.indexOf('?') !== -1 ? '&' : '?';
    newUrl = url + separator + key + '=' + value;
  }
  return newUrl;
}

function removeSpotImParams(url) {
  return removeParams(url, [
    'utm_source',
    'utm_medium',
    'utm_content',
    'prerender',
    'spot_im_state',
    'spot_im_comment_id',
    'spot_im_reply_id',
    'spot_im_expand_reply',
    'spot_im_highlight_immediate',
    'spot_im_scroll_to_comments',
    'spot_im_source',
    'spot_im_email_settings'
  ]);
}

export default {
  parseUrl,
  // build: buildQueryString,
  buildUrl,
  getKey,
  setKey,
  removeParams,
  //clean: cleanQueryString,
  removeSpotImParams,
  hasQueryString
};
